module.exports = __webpack_public_path__ + "static/media/jcb.bba137c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Booking/svg/jcb.png
// module id = 1482
// module chunks = 0